import React, { useEffect, useState } from "react";
import { Divider, Grid } from "@mui/material";
import { Box } from "@mui/material";
import ImageDsMarketing from "../../assets/preload/logo.png";
import { useStyles } from "./styles";
import { TimelineColumn } from "../../components/TimelineColumn";
import { ConnectionWhatsapp } from "./Whatsapp";
import { StoreSettings } from "./StoreSettings";
import { EndScreen } from "./EndScreen";
import { useQuery } from "react-query";
import { listStores } from "../../services/stores";
import { Store } from "../../types/stores";
import { useToast } from "../../hooks/useToast";
import { SocialNetworks } from "./ SocialNetworks";
import { CompanySegmentProvider } from "../../contexts/CompanySegment";
import { queryClient } from "../../services/queryClient";
// import { useCompanySegment } from "../../hooks/useCompanySegment";

export const STORE_NAME_PATTERN = "Loja 1";

export function InitialSettings() {
  const [value, setValue] = useState(0);
  const [firstStore, setFirstStore] = useState({} as Store);
  const [idStore, setIdStore] = useState<number | undefined>(undefined);

  const styles = useStyles();
  const toast = useToast();

  const { data: stores, isLoading: loadingStores } = useQuery(
    "listStores",
    async () => {
      const stores: Store[] = await listStores();
      return stores;
    }
  );

  useEffect(() => {
    const storesLength = stores ? stores.length : null;

    if (!storesLength || storesLength === 0) {
      // toast.show(
      //   "Erro ao encontrar sua loja. Por favor, entre em contato com o suporte.",
      //   { severity: "warning" }
      // );
      return;
    }

    if (idStore === undefined) {
      const storeOneExists = stores?.find(
        (store) => store.nome_loja === STORE_NAME_PATTERN
      );

      if (storeOneExists) {
        setFirstStore(storeOneExists);
        setIdStore(storeOneExists.id_loja);
        return;
      }

      /**
       * If the store with store name 'Loja 1' does not exist,
       * look for the last store in the store array as it is the
       * oldest store saved
       */
      const lastStore = stores![storesLength - 1];

      setFirstStore(lastStore);
    } else {
      const storeOneExists = stores?.find((store) => store.id_loja === idStore);

      if (storeOneExists) {
        setFirstStore(storeOneExists);
        return;
      }
    }
  }, [stores, toast, idStore]);

  function advance(newValue: number) {
    queryClient.invalidateQueries("listStores");
    setValue(newValue);
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    queryClient.invalidateQueries("listStores");
    if (!loadingStores) {
      setValue(newValue);
    }
  };

  const tabs = [
    {
      label: "Configurações da sua empresa",
      index: 0,
      children: (
        <StoreSettings
          store={firstStore}
          loadingStore={loadingStores}
          onAdvance={() => advance(1)}
        />
      ),
    },
    {
      label: "Conectar Whatsapp",
      index: 1,
      children: <ConnectionWhatsapp advance={advance} store={firstStore} />,
    },
    {
      label: "Conectar redes sociais",
      index: 2,
      children: <SocialNetworks advance={advance} />,
    },
  ];

  return (
    <CompanySegmentProvider>
      <Grid sx={{ marginTop: "104px" }}>
        <Grid item xs={12} className={styles.gridMenuTop}>
          <Box className={styles.boxImg}>
            <img
              id="logo-ds-marketing"
              src={ImageDsMarketing}
              alt="ds-marketing"
              className={styles.image}
            />
          </Box>
          <Divider />
        </Grid>
        <Grid container className={styles.containerTimiline}>
          {value !== 3 ? (
            <Grid item sx={{ paddingRight: "4rem" }}>
              <TimelineColumn
                tabs={tabs}
                padding="0px 0 0 0"
                handleChange={handleChange}
                value={value}
              />
            </Grid>
          ) : (
            <EndScreen advance={advance} />
          )}
        </Grid>
      </Grid>
    </CompanySegmentProvider>
  );
}
